import { createReducer } from '@reduxjs/toolkit'

import { adGroupNegativeKeywordsTableColumnsConfig } from 'configuration/tables/negativeKeywordsTable'
import { serializeColumns } from 'helpers/tables'
import { defaultTab, getDefaultTable } from 'reducers/ui/defaults'

const initialState = {
    ...defaultTab,
    table: getDefaultTable(
        serializeColumns(adGroupNegativeKeywordsTableColumnsConfig),
        {
            sorter: {
                field: 'amazon_creation_date',
                order: 'descend',
            },
        }
    ),
}

export default createReducer(initialState, () => {})
